import React from 'react';
import { ModalBox, useMediaQueryContext, useModalContext } from '@fourthwall/components';
import * as S from './SubscriptionLimitModal.styled';
export const SubscriptionLimitModal = ({ title = 'Limit reached', content, }) => {
    const { close } = useModalContext();
    const media = useMediaQueryContext();
    return (React.createElement(ModalBox, { width: media.tablet ? '480px' : undefined, title: title, onClose: close },
        React.createElement(S.Content, null, content)));
};
